import carSourceShare from './carSourceShare.json';
import common from './common.json';
import component from './component.json';
import home from './home.json';
import menu from './menu.json';
import validateRule from './validateRule.json';

// 文件名即为 namespace
export default {
  carSourceShare,
  common,
  component,
  home,
  validateRule,
  menu,
};
